import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../functions/config';

const Signup = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!formData.username) newErrors.username = 'Username is required';
    if (!emailPattern.test(formData.email)) newErrors.email = 'Invalid email address';
    if (!formData.first_name) newErrors.first_name = 'First name is required';
    if (!formData.last_name) newErrors.last_name = 'Last name is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const response = await fetch(`${config.BASE_URL}/api/register/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        const result = await response.json();

        if (response.ok) {
          setMessage("✅ Registration successful! A password has been sent to your email.");
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setMessage(`❌ ${result.error || "Registration failed."}`);
        }
      } catch (error) {
        setMessage("❌ Error occurred. Please try again later.");
      }
    }
  };

  return (
    <div style={styles.pageContainer}>
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3 fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">📚 Library</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/about">About</a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Login">Login</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Signup">Register</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Signup Form */}
      <div style={styles.formContainer} className='container mt-4 mb-2 ml-5 mr-5'>
        <div style={styles.card}>
          <h2 style={styles.heading}className='text-light text-center'>Sign Up</h2>
          {message && <div style={message.startsWith("✅") ? styles.successMessage : styles.errorMessage}>{message}</div>}
          <form onSubmit={handleSubmit}>
            <div style={styles.formGroup}>
              <label style={styles.label}className='text-light'>Username</label>
              <input
                type="text"
                className='px-5'
                style={errors.username ? styles.inputError : styles.input}
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
              {errors.username && <div style={styles.errorText}>{errors.username}</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label} className='text-light'>Email</label>
              <input
                type="email"
                style={errors.email ? styles.inputError : styles.input}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div style={styles.errorText}>{errors.email}</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}className='text-light'>First Name</label>
              <input
                type="text"
                style={errors.first_name ? styles.inputError : styles.input}
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
              />
              {errors.first_name && <div style={styles.errorText}>{errors.first_name}</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}className='text-light'>Last Name</label>
              <input
                type="text"
                style={errors.last_name ? styles.inputError : styles.input}
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
              />
              {errors.last_name && <div style={styles.errorText}>{errors.last_name}</div>}
            </div>

            <button type="submit" style={styles.submitButton}>Register</button>
          </form>
          <a href="/login" className="text-primary pt-5 mt-5"><button type="submit" className="mb-3" style={styles.submitButton}>Login</button>    </a>   

        </div>
      </div>
          {/* Footer */}
          <footer style={styles.footer}>
        <p className="mb-0">&copy; 2024 Library Management System | Designed with ❤️ by Your Team</p>
      </footer>
    </div>
  );
};

// Inline Styles
const styles = {

  
  pageContainer: {
    fontFamily: "'Roboto', sans-serif",
    minHeight: "100vh",
    backgroundImage: "url('https://www.acg.edu/wp-content/uploads/2022/06/IGA-student-journal-featured-image.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundBlendMode: "overlay",
    opacity: "0.9",
    display: "flex",
    flexDirection: "column",
    paddingTop: "80px",

  },

  formContainer: {
    maxWidth: "700px",
    borderRadius: "20px",
    flex: 2,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    margin: "auto",
  },

  card: {
    backgroundColor: "transparent",
    padding: "10px",
    borderRadius: "10px",
  },

  heading: {
    color: "#fff",
    marginBottom: "20px",
  },

  formGroup: {
    marginBottom: "15px",
  },

  label: {
    display: "block",
    marginBottom: "5px",
    color: "#fff",
    fontWeight: "bold",
  },

  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid black",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    color: "#fff",

  },

  inputError: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid red",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "red",
  },

  submitButton: {

    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "orange",
    color: "#fff",
    fontSize: "16px",
    border: "none",
    cursor: "pointer",
    marginTop: "10px",
  },

  errorText: {
    color: "red",
    fontSize: "14px",
  },

  successMessage: {
    color: "green",
    textAlign: "center",
    marginBottom: "15px",
  },

  errorMessage: {
    color: "red",
    textAlign: "center",
    marginBottom: "15px",
  },
  footer: {
    backgroundColor: "#343a40",
    color: "white",
    padding: "15px 0",
    textAlign: "center",
  },
  
};

export default Signup;
